
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
//@ts-ignore
import { TiptapVuetify, Bold, Italic, Link, BulletList, ListItem, Paragraph, HardBreak, History } from 'tiptap-vuetify';
import { htmlToText, textToHtml } from '@/content/rich-text';

/**
 * Text with bold, italic, links and bullet lists, edited with buttons. It is stored as the site's plain text format
 * (see content/rich-text), so only what the site can show is offered.
 */
@Component({ components: { TiptapVuetify } })
export default class RichTextField extends Vue {
  @Prop({ required: true }) readonly value!: string;
  @Prop({ required: true }) readonly label!: string;
  @Prop({ default: '' }) readonly hint!: string;
  @Prop({ type: Array, default: () => [] }) readonly errorMessages!: string[];

  extensions = [History, Bold, Italic, Link, BulletList, ListItem, Paragraph, HardBreak];
  html = '';
  /** The text this field last sent: when the value comes back as that, the editor keeps its own HTML (and cursor). */
  sent: string | null = null;

  @Watch('value', { immediate: true })
  onValue(value: string): void {
    if (value === this.sent) return;
    this.sent = value;
    this.html = textToHtml(value || '');
  }

  onInput(html: string): void {
    this.html = html;
    this.sent = htmlToText(html);
    if (this.sent !== this.value) this.$emit('input', this.sent);
  }
}
